import { getExtensionWithoutDotFromFileName } from 'owa-file';
import AttachmentModel from '../store/schema/AttachmentModel';

export default function getAttachmentFileType(attachmentModel: AttachmentModel) {
    const emptyFileType = '';
    let fileType = emptyFileType;
    if (attachmentModel && attachmentModel.model) {
        fileType =
            getExtensionWithoutDotFromFileName(attachmentModel.model.Name || emptyFileType) ||
            attachmentModel.model.ContentType ||
            emptyFileType;
    }
    return fileType;
}
